<template>
  <div class="ie">
    <h1>Sorry, this Webstore cannot run on Internet Explorer</h1>
    <p>Try Chrome or Firefox.</p>
    <div class="ie-card"></div>
  </div>
</template>

<script>
export default {
  name: "IE"
};
</script>

<style scoped>
.ie {
  background-color: #f6f5f4;
  position: fixed;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-family: monospace;
  color: darkgrey;
}

.ie-card {
  width: 625px;
  height: 380px;
  background-image: url("~@/assets/ie_end.jpg");
  background-size: cover;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 30px;
}
</style>
